import React, { useState } from 'react'
import styled from 'styled-components'
import Tab from './Tab'
import { SM_BREAKPOINT } from '../../../../breakpoints'

export default function Tabs ({ places, onChange }) {
  const [activeIndex, setActiveIndex] = useState(0)

  const handlePlacePress = (index, place) => {
    setActiveIndex(index)

    if (onChange) {
      onChange(place)
    }
  }

  return (
    <Container >
      {places.map((place, index) => (
        <Tab
          name={place.Name}
          key={index}
          active={activeIndex === index}
          onPress={() => handlePlacePress(index, place)}
        />
      ))}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;

  @media screen and (max-width: ${SM_BREAKPOINT}em) {
    flex-direction: column;
  }

`
